module.exports = __webpack_public_path__ + "img/picto-trustedShops.23d9c96.png";